import { CustomerInfo } from '../../entities/CustomerInfo'
import { httpClient } from '../http/httpClient'

export async function customerInfo(id: string) {
  const { data } = await httpClient.get<CustomerInfo>(`/customer/${id}`, {
    headers: {
      'x-mock-response-name': 'Get customer by ID',
    },
  })

  return data
}
